import { t } from 'i18next'
import React from 'react'
import { Checkbox, FormControlLabel } from '@mui/material'

function PosRequestConfirmTerm({ objectDto, term, onTermChange }) {
    return (
        <div id="term" style={{ display: objectDto.checked === 1 ? "block" : "none" }}>
            <div data-toggle="collapse" data-target="#search-box-" className="header-box">
                <FormControlLabel control={<Checkbox id="term" name="term" checked={term} onChange={(e) => onTermChange(e)} className='iCheck-checkbox'
                    sx={{
                        color: "black", "&.Mui-checked": { color: "#c4960c", }, "& .MuiSvgIcon-root": {
                            fontSize: "20px", "@media (max-width: 960px)": {
                                fontSize: "16px",
                            },
                            "@media (max-width: 687px)": {
                                fontSize: "14px",
                            },
                        }
                    }} />}
                    sx={{
                        "& .MuiFormControlLabel-label": {
                            fontSize: "14px", fontWeight: "bold",
                            "@media (max-width: 960px)": {
                                fontSize: "12px",
                            },
                            "@media (max-width: 687px)": {
                                fontSize: "10px",
                            },
                        }
                    }}
                    label={t('postermtitle')} />
            </div>
            <div className="collapse in" id="search-box-6">
                <div className="border-box-sc row">
                    <div className="col-md-12 ">
                        <div className="form-group col-md-12">
                            <div className="col-md-12  description-small-customer">
                                <ul>
                                    <li>
                                        <i className="fa fa-ellipsis-h" aria-hidden="true" />
                                        <span>{t('posterm1')}{" "}</span>
                                    </li>
                                    <li>
                                        <i className="fa fa-ellipsis-h" aria-hidden="true" />
                                        <span>{t('posterm2')}{" "}</span>
                                    </li>
                                    <li>
                                        <i className="fa fa-ellipsis-h" aria-hidden="true" />
                                        <span>{t('posterm3')}{" "}</span>
                                    </li>
                                    <li>
                                        <i className="fa fa-ellipsis-h" aria-hidden="true" />
                                        <span>{t('posterm4')}{" "}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PosRequestConfirmTerm